const config = {
  VERSION: process.env.VERSION,
};

export default config;

export const SERVER_API_URL = process.env.SERVER_API_URL;

export const AUTHORITIES = {
  ADMIN: 'ROLE_ADMIN',
  USER: 'ROLE_USER',
};

export const messages = {
  DATA_ERROR_ALERT: 'Internal Error',
};

export enum SIDE_BAR_ITEM {
  ONLY_ONE_SUBSCRIPTION = '1',
  ONLY_ONE_CLAIM = '2',
  ACCOUNT = '3',
  CONTACT = '4',
  HELP = '5',
  MULTIPLE_SUBSCRIPTION = '6',
  MULTIPLE_CLAIM = '7',
}
export const APP_DATE_STICKY_FORMAT = 'DD-MM-YYYY'
export const APP_DATE_FORMAT = 'DD/MM/YY HH:mm';
export const APP_TIMESTAMP_FORMAT = 'DD/MM/YY HH:mm:ss';
export const APP_LOCAL_DATE_FORMAT = 'DD/MM/YYYY';
export const APP_LOCAL_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm';
export const APP_LOCAL_DATETIME_FORMAT_Z = 'YYYY-MM-DDTHH:mm Z';
export const APP_WHOLE_NUMBER_FORMAT = '0,0';
export const APP_TWO_DIGITS_AFTER_POINT_NUMBER_FORMAT = '0,0.[00]';
export const APP_REG_EX_ONLY_NUMBER=/^\d+$/;
export const APP_REG_EX_NUMBER_AND_CARACTER=/^[a-zA-Z0-9 .!?"-]+$/;
export const APP_REG_EX_ONLY_CARACTER=/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð '-]+$/;
export const MAX_LENGTH_POSTAL_CODE =5;
export const MAX_LENGTH_PHONE =10;
export enum HANDLE_NEXT_ACTION {
  UPLOAD = 'UPLOAD',
  FOLLOW = 'FOLLOW',
  NEXT = 'NEXT',
}

export enum FEED_BACK_ENTITY_TYPE {
  SUBSCRIPTION = 1,
  CLAIM = 2,
}
